module.exports = __webpack_public_path__ + "media/images/filled_star-a5d9ed3176d04a5b184860b625dba545.svg";